import UbicacionService from 'src/modules/ubicacion/ubicacionService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';
import UbicacionListActions from 'src/modules/ubicacion/list/ubicacionListActions';
import layoutActions from 'src/modules/layout/layoutActions';
import moment from 'moment';

const prefix = 'UBICACION_FORM';

const ubicacionFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: ubicacionFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await UbicacionService.find(id);
      }

      dispatch({
        type: ubicacionFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: ubicacionFormActions.INIT_ERROR,
      });

      getHistory().push('/ubicacion');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: ubicacionFormActions.CREATE_STARTED,
      });

      await UbicacionService.create(values);

      dispatch({
        type: ubicacionFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.ubicacion.create.success'),
      );

      dispatch(UbicacionListActions.doFetchCurrentFilter());
      // close/hide form drawer
      dispatch(
        layoutActions.doVisibleDrawer({
          drawerId: 'DrawerUbicacionFormPage',
          drawerVisible: false,
          drawerChanged: moment().unix(),
          drawerUpdateComponent: null,
        }),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: ubicacionFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ubicacionFormActions.UPDATE_STARTED,
      });

      await UbicacionService.update(id, values);

      dispatch({
        type: ubicacionFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.ubicacion.update.success'),
      );

      dispatch(UbicacionListActions.doFetchCurrentFilter());
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: ubicacionFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default ubicacionFormActions;
